import scroll from './scroll/scroll'
import iconSvg from './iconSvg/svg'

const install = function (Vue, options) {
  // 滚动组件
  Vue.component(
    'TD-scroll', scroll
  )
  // svg渲染组件
  Vue.component(
    'icon-svg', iconSvg
  )
}

export default {
  install
}



// WEBPACK FOOTER //
// ./src/components/common/index.js